import { ActionCardData } from './types'
import { ActionCardModel } from './actionCard'

export interface INodeVisibilityRule {
  /**
   * Checks if a node is visible according to the rule.
   * @param node The node to check.
   * @returns true if visible, false otherwise. False has to be returned only if you are sure, e.g. if data is not specified it is better to return true.
   */
  check(node?: any, actionCardSource?: ActionCardModel | ActionCardData): boolean
}

export class NodeVisibilityRulesCollection implements Iterable<INodeVisibilityRule> {
  private __rules: INodeVisibilityRule[] = []

  public check(node?: any | null, actionCardSource?: ActionCardModel | ActionCardData): boolean {
    for (const rule of this) {
      if (!rule.check(node, actionCardSource)) {
        return false
      }
    }
    return true
  }

  public addRange(rules?: Iterable<INodeVisibilityRule> | null): void {
    if (!rules) {
      return
    }
    for (const rule of rules) {
      this.add(rule)
    }
  }

  public add(rule?: INodeVisibilityRule | null): void {
    if (!rule) {
      return
    }
    if (!this.__rules.includes(rule)) {
      this.__rules.push(rule)
    }
  }

  public deleteRange(rules?: Iterable<INodeVisibilityRule> | null): void {
    if (!rules) {
      return
    }
    for (const rule of rules) {
      this.delete(rule)
    }
  }

  public delete(rule?: INodeVisibilityRule | null): void {
    if (!rule) {
      return
    }
    this.__rules = this.__rules.filter(r => r !== rule)
  }

  public clear(): void {
    this.__rules = []
  }

  /**
   * This class must not be serialized, because it can contain functions (inside the rules).
   */
  public toJSON(): undefined {
    return undefined
  }

  *[Symbol.iterator](): Iterator<INodeVisibilityRule> {
    if (!this.__rules) {
      return
    }
    for (const rule of this.__rules) {
      yield rule
    }
  }
}
